import { NeoBrandsData } from "../MyReferralPage/MyReferralRedeemnow";
import React, { useState } from "react";
import RedeemHistory from "./RedeemHistory";
import { useTranslation } from "react-i18next";

const RedeemPage = () => {
  // State to manage active tab
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("rewards");

  return (
    <div className=" flex justify-center items-center w-full mt-[6rem] fixed lg:ml-[7.3rem] md:ml-0 ml-0">
      <div className="flex flex-col items-center w-full">
        {/* Buttons for toggling between Redeem Rewards and Redeem History */}
        <div className="flex mb-6 bg-[#FFFFFF] py-4 px-8 rounded-full gap-2">
          <button
            onClick={() => setActiveTab("rewards")}
            className={`font-semibold ${
              activeTab === "rewards"
                ? "bg-[#0989C20F] bg-opacity-10 rounded-full px-4 py-2 text-[#056E9C]"
                : " text-[#555656]"
            }`}
          >
            {t("page.referral.rewads")}
          </button>
          <button
            onClick={() => setActiveTab("history")}
            className={`font-semibold ${
              activeTab === "history"
                ? "bg-[#0989C20F] bg-opacity-10 rounded-full px-4 py-2 text-[#056E9C]"
                : "text-[#555656]"
            }`}
          >
            {t("redeem.history.redeemhistory")}
          </button>
        </div>
        <div className="flex justify-center items-center">
          {/* Table for Redeem Rewards */}
          {activeTab === "rewards" && <NeoBrandsData />}

          {/* Table for Redeem History */}
          {activeTab === "history" && <RedeemHistory />}
        </div>
      </div>
    </div>
  );
};

export default RedeemPage;
